"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionSize = exports.OptionSizes = void 0;
const typegate_1 = require("typegate");
exports.OptionSizes = {
    full: 'full',
    half: 'half',
    oneThird: 'oneThird',
};
exports.optionSize = typegate_1.t.union(typegate_1.t.literal('full'), typegate_1.t.literal('half'), typegate_1.t.literal('oneThird'));
